
export const getAccountSettings = {
    REQUEST: 'GET_ACCOUNT_SETTINGS_REQUEST',
    SUCCESS: 'GET_ACCOUNT_SETTINGS_SUCCESS',
    FAILURE: 'GET_ACCOUNT_SETTINGS_FAILURE'
}
export const updateAccountSettings = {
    REQUEST: 'UPDATE_ACCOUNT_SETTINGS_REQUEST',
    SUCCESS: 'UPDATE_ACCOUNT_SETTINGS_SUCCESS',
    FAILURE: 'UPDATE_ACCOUNT_SETTINGS_FAILURE'
}


export const getAdminAccountSettings = {
    REQUEST: 'GET_ADMIN_ACCOUNT_SETTINGS_REQUEST',
    SUCCESS: 'GET_ADMIN_ACCOUNT_SETTINGS_SUCCESS',
    FAILURE: 'GET_ADMIN_ACCOUNT_SETTINGS_FAILURE'
}
export const updateAdminAccountSettings = {
    REQUEST: 'UPDATE_ADMIN_ACCOUNT_SETTINGS_REQUEST',
    SUCCESS: 'UPDATE_ADMIN_ACCOUNT_SETTINGS_SUCCESS',
    FAILURE: 'UPDATE_ADMIN_ACCOUNT_SETTINGS_FAILURE'
}